export const DEFAULT_IMAGE = "https://explore.neftipedia.com/assets/images/images/nft_logo.png";